/* eslint-disable @typescript-eslint/ban-ts-comment */
import "./App.css";
import routes from "./routes/routes";
import { useContext, useEffect } from "react";
import { UserContext } from "./contexts/user.context";
import { ToastContainer } from "react-toastify";
import ThreeD from "./routes/dashboard/threeD/ThreeD";
import AddPoint from "./routes/dashboard/addPoint/AddPoint";
import useWalkieTalkie from "./hooks/useWalkieTalkie";
import useCSSVars from "./hooks/useCSSVars";
import "react-toastify/dist/ReactToastify.css";
import { UnderMaintenance } from "./routes/underMaintenance/UnderMaintenance.route";
import "filepond/dist/filepond.min.css";
import { registerPlugin } from "react-filepond";
// @ts-ignore
import FilePondPluginImageExifOrientation from "filepond-plugin-image-exif-orientation";
// @ts-ignore
import FilePondPluginImagePreview from "filepond-plugin-image-preview";
import "filepond-plugin-image-preview/dist/filepond-plugin-image-preview.css";
import { PasswordReset } from "./components/PasswordReset/PasswordReset";
import { useLocation } from "react-router-dom";
import { useCommanData } from "./contexts/commanData.context";

// Register the plugins
registerPlugin(FilePondPluginImageExifOrientation, FilePondPluginImagePreview);

function App() {
  const {
    isASDCAdmin,
    isUser,
    userData,
    socket,
    serverMaintenance,
    setServerMaintenance,
  } = useContext(UserContext);
  const { setOptions } = useCommanData();

  useCSSVars();
  useWalkieTalkie();
  const location = useLocation();

  useEffect(() => {
    setOptions([]);
  }, [location.pathname]);

  useEffect(() => {
    socket.on(`ServerMaintenance`, (serverAlert: any) => {
      // console.log(serverAlert);
      if (serverAlert.status === "Down") {
        localStorage.setItem("serverMaintenance", "true");
        setServerMaintenance(true);
      }
      if (serverAlert.status === "Up") {
        localStorage.removeItem("serverMaintenance");
        setServerMaintenance(false);
      }
    });
    return () => {
      socket.close();
    };
  }, []);

  return (
    <>
      {serverMaintenance && <UnderMaintenance />}

      {userData[0]?.isPasswordResetRequired ? (
        <PasswordReset />
      ) : (
        routes(isASDCAdmin, isUser, userData[0]?.UserCRUD_Operations)
      )}

      <ToastContainer />
      <ThreeD opacity={false} />
      <AddPoint opacity={false} />
    </>
  );
}

export default App;
